var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form-group",
    {
      attrs: {
        "invalid-feedback": _vm.error,
        label: _vm.__(_vm.config.label || _vm.config.name, ["titleCase"]),
        "label-for": "expandable-textarea-" + _vm.config.name
      }
    },
    [
      _vm.config.description
        ? _c("small", { staticClass: "form-text mb-2" }, [
            _vm._v(_vm._s(_vm.config.description))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("textarea", {
        staticClass: "form-control",
        attrs: {
          id: "expandable-textare-" + _vm.config.name,
          rows: _vm.lines,
          maxlength: _vm.config.length || "",
          disabled: _vm.config.readonly
        },
        domProps: { value: _vm.value },
        on: {
          input: function(e) {
            return _vm.onChange(e.target.value)
          }
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c8f7454", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c8f7454","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/form-elements/ExpandableTextComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3c8f7454","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/form-elements/ExpandableTextComponent.vue
// module chunks = 0